/**
 *  @fileOverview: 首页-昨日top5
 *  @creator: CaoYanqi
 *  @Date: 2019/6/10
 *  @Last Modified by: 
 *  @Last Modified time:
 */
import * as React from 'react'
import { connect } from 'react-redux'
import { Popover, Empty, Tooltip, Radio } from "antd";
import { Link, Redirect } from "react-router-dom";
import QueueAnim from 'rc-queue-anim';
import { Utils } from '@/tools/utils';
import './top5.less'
import { SYSTEMPermission } from "../../../permissions/system"
import { hasPermission } from '@lima/seraphim-react';

class Top5 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      topType: 'person', // product
    };
    this.content = (
      <div className="data_count_po_tips">
        <p className="title">统计规则：</p>
        <p className="desc">按承保时间统计昨日0点～24时，包含当前账户及所有下级机构团队。</p>
        <p className="title marTop24">最高保费业务员：</p>
        <p className="desc">统计时间段内已支付保费-已撤单保费-已退保保费，保费排名前五的业务员。</p>
        <p className="title marTop24">最热销产品：</p>
        <p className="desc">统计时间段内已支付保费-已撤单保费-已退保保费，保费排名前五的保险产品。</p>
      </div>
    );
  }
  componentDidMount() { }

  jumptoDetail = () => {
    this.state.topType === 'person' ?
      this.props.history.push('/businessReport/orgReportM') :
      this.props.history.push('/businessReport/spuReportM')
  };

  render() {
    return (
      <div className="top5_card_wrap">
        <div className="divider"> </div>
        <div className="header">
          <div className="title">昨日TOP 5
            {
              // ?提示
              !(this.props.pageConfig && this.props.pageConfig.extendBtnClose) &&
              <Popover placement="bottomLeft" title='' content={this.content} trigger="hover">
                <div className="count_tips"></div>
              </Popover>
            }
          </div>
          {hasPermission(SYSTEMPermission.MY_PRODUCT) && !this.props.pageLoading && <Link to={'/productSys/productRepository'} onClick={() => {
            Utils.customTrack('MerchantHomeClick', {
              element_content: '我的产品'
            });
          }}>我的产品</Link>}
        </div>
        <div className="content">
          <Radio.Group value={this.state.topType}
            onChange={e => {
              Utils.customTrack('MerchantHomeClick', {
                element_content: e.target.value === 'person' ? '最高保费业务员' : '最高热销产品'
              });
              this.setState({ topType: e.target.value });
            }}
            className="btn_group"
            style={{ width: '100%' }}>
            <Radio.Button value="person" >最高保费业务员</Radio.Button>
            <Radio.Button value="product"> 最热销产品 </Radio.Button>
          </Radio.Group>
          <div className="list_wrap">
            <QueueAnim type='right' duration={100} interval={50}>
            {
              (this.state.topType==='person'?this.props.yesterdayAgencyTopFive:this.props.yesterdayProductTopFive ||[])
              .map((item,index)=>{
                return(
                  <div className="item_wrap" key={index}>
                    <div className="title_box">
                      <span className={`icon_index ${index<3?`active`:``}`}>{index + 1}</span>
                      <Tooltip placement={"topLeft"} title={item.agencyName || item.spuName}>
                        <span className="title">{item.agencyName  || item.spuName}</span>
                      </Tooltip>
                    </div>
                    {
                      this.state.topType==='person'?
                        <span className="desc">{item.premium || item.productCount || '0.00'}元</span>:
                        <span className="desc">{item.premium || item.productCount || '0'}件</span>
                    }
                  </div>
                )
              })
            }
            </QueueAnim>
            {
                (this.state.topType==='person'?this.props.yesterdayAgencyTopFive:this.props.yesterdayProductTopFive).length===0 &&
                <div className="empty-box">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                </div>
              }
          </div>
          {
            !(this.props.pageConfig && this.props.pageConfig.extendBtnClose) && hasPermission(SYSTEMPermission.ORGREPORTM) && !this.props.pageLoading &&
            <div className="expand_btn" key="btn" onClick={() => {
              Utils.customTrack('MerchantHomeClick', {
                element_content: '昨日TOP5-查看全部'
              });
              this.jumptoDetail()
            }}>查看全部</div>
          }
        </div>
      </div>
    )
  }
}

function mapState(state) {
  return {
    token: state.token
  }
}
export default connect(mapState)(Top5)
